import { DefaultOptionType } from 'antd/lib/select';
import { ControlledSelect } from 'modules/common/components';
import { CATEGORY_ID } from 'modules/products/constants/categoryId';
import { useWoocommerceCategories } from 'modules/products/hooks/useWoocommerceCategories';
import { FC, useMemo } from 'react';
import { UseControllerProps } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

type PropTypes = {
  controlled: UseControllerProps<any>;
};

const categoriesBlackList = [CATEGORY_ID.MEDICAL_SUPPLY];

const CategorySelect: FC<PropTypes> = ({ controlled }) => {
  const { t } = useTranslation('products.CategorySelect');

  const { categories: woocommerceCategories, loading } =
    useWoocommerceCategories();

  const categories = useMemo(() => {
    if (!woocommerceCategories) {
      return undefined;
    }

    return woocommerceCategories.reduce((ctgs, { id, name }) => {
      if (categoriesBlackList.includes(id)) {
        return ctgs;
      }
      return [...ctgs, { value: id, label: name }];
    }, [] as DefaultOptionType[]);
  }, [woocommerceCategories]);

  return (
    <ControlledSelect
      options={categories}
      loading={loading}
      className={styles.select}
      controlled={controlled}
      placeholder={t('selectProductCategory')}
    />
  );
};

export default CategorySelect;
